export const AutoAdjustDateLevel = {
  Off: 0,
  AdjustSelf: 1,
  MoveChildren: 2,
  ResolveConstraints: 3
};

// Note: must be in same order to match indexes above
export const AutoAdjustLevelLabel = [
  "Disable auto-adjustment",
  "Adjust item end dates",
  "Adjust children and end dates",
  "Resolve constraints and adjust children"
];

export const AutoAdjustLevelDescription = [
  "Dates will not be automatically adjusted.",
  "When changing an item's start date, the item's end date will also be adjusted to maintain the item's duration.",
  "When changing a parent item's start date, its children will be adjusted by the same amount of time. This is in addition to adjusting item end dates.",
  "Items will automatically be adjusted to satisfy set dependencies and date constraints. This is in addition to adjusting child items and item end dates."
];

const createAutoAdjustOption = id => {
  return {
    identifier: id,
    name: AutoAdjustLevelLabel[id],
    description: AutoAdjustLevelDescription[id]
  };
};

export const AutoAdjustDateOptions = [
  createAutoAdjustOption(AutoAdjustDateLevel.Off),
  createAutoAdjustOption(AutoAdjustDateLevel.AdjustSelf),
  createAutoAdjustOption(AutoAdjustDateLevel.MoveChildren),
  createAutoAdjustOption(AutoAdjustDateLevel.ResolveConstraints)
];
